```vue
<template>
  <footer class="bg-white border-t border-slate-200 py-4 mt-8">
    <div class="container mx-auto px-6 text-center text-sm text-slate-600">
      <p>
        Desarrollado por Alvarez Garcia Gonzalo Emanuel
      </p>
      <div class="flex items-center justify-center gap-4 mt-2">
        <a 
          href="mailto:alvarez.gonza86@gmail.com" 
          class="hover:text-indigo-600 transition-colors"
        >
          <font-awesome-icon :icon="['fas', 'envelope']" class="mr-1" />
          alvarez.gonza86@gmail.com
        </a>
        <a 
          href="https://wa.me/5493855778305" 
          target="_blank"
          class="hover:text-indigo-600 transition-colors"
        >
          <font-awesome-icon :icon="['fab', 'whatsapp']" class="mr-1" />
          +5493855778305
        </a>
      </div>
    </div>
  </footer>
</template>
```